import { render, staticRenderFns } from "./NetlinkTable.vue?vue&type=template&id=1951a956"
import script from "./NetlinkTable.vue?vue&type=script&lang=js"
export * from "./NetlinkTable.vue?vue&type=script&lang=js"
import style0 from "./NetlinkTable.vue?vue&type=style&index=0&id=1951a956&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports